import { render, staticRenderFns } from "./WebsiteIcon.vue?vue&type=template&id=5f5fd27c&scoped=true"
import script from "./WebsiteIcon.vue?vue&type=script&lang=js"
export * from "./WebsiteIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5fd27c",
  null
  
)

export default component.exports